/**
 * Rol-helper (client). Eén gedeelde bron voor "telt deze medewerker mee in het rooster?".
 *
 * Roosterbaar = NIET teamleider-only: een rollen-array die 'medewerker' mist maakt iemand
 * niet-roosterbaar — een pure teamleider ['teamleider'], én een lege array []. Een
 * ontbrekend of niet-array rollen-veld telt wél als roosterbaar (≙ ['medewerker']).
 *
 * Twee vormen met exact dezelfde definitie:
 *   - isRoosterbaarVolgensRollen(rollen): neemt de rollen-array direct (useRol krijgt die zo
 *     van /api/wie-ben-ik).
 *   - isRoosterbaar(mw): objectvorm die mw?.rollen eruit haalt — de gedeelde bron voor de
 *     UI-callers (Weekrooster / exportMaandroosterExcel / NieuwRuilverzoekModal / Beheer),
 *     die eerder elk een eigen kopie hadden.
 * Het spiegelbeeld isTeamleiderOnly in de engine blijft bewust apart: lib/ gaat niet mee in
 * de deploy-zip (alleen engine/ en data/), dus de engine mag hier niet van afhangen.
 */
export function isRoosterbaarVolgensRollen(rollen) {
  return !(Array.isArray(rollen) && !rollen.includes('medewerker'));
}

// Objectvorm voor de UI-callers: haalt de rollen-array uit een medewerker-object.
export const isRoosterbaar = (mw) => isRoosterbaarVolgensRollen(mw?.rollen);
